/* eslint-disable react/jsx-filename-extension */
import React from "react";
import ReactDOM from "react-dom";
import App from "./components/App";
import { asyncWithLDProvider } from "launchdarkly-react-client-sdk";

(async () => {
  const LDProvider = await asyncWithLDProvider({
    clientSideID: window.ENVCONFIG.launchDarkly.clientID,
    user: {
      key: localStorage.getItem("X-DPZ-D") || false,
      custom: {
        clientTime: new Date().getTime(),
        market: window.ENVCONFIG.market
      }
    },
    reactOptions: {
      useCamelCaseFlagKeys: false
    }
  });

  ReactDOM.render(
    <LDProvider>
      <App />
    </LDProvider>,
    document.getElementById("dpz-chat-app")
  );
})();
